export const InitialAdjustData = {
  bill_number: "",
  vendor: "",
};
